class StickyBuyButton extends HTMLElement {
  constructor() {
    super();

    this.activeClass = 'wt-product__sticky-buy--show';
    // Force opening size modal on next CTA after minicart closes
    this.forceSizeModal = false;
    window.addEventListener('minicart:closed', () => {
      this.forceSizeModal = true;
    });
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    const addToCartModule = document.querySelector('.wt-product__add-to-cart');
    const btn = this.querySelector('button');

    const forObserver = document.querySelectorAll('.wt-product__add-to-cart, .wt-footer, .wt-product__name');

    let intersected = [];

    btn.addEventListener('click', e => {
      console.log('Sticky button clicked!');
      e.preventDefault();

      // Check if this is a restock notification product
      const isRestockProduct = btn.hasAttribute('data-is-coming-soon');

      if (isRestockProduct) {
        const modalSelector = btn.dataset.modal;
        const modal = modalSelector ? document.querySelector(modalSelector) : null;
        if (modal && typeof modal.show === 'function') {
          modal.show(btn);
        }
        return;
      }

      // Check if this is a single U size product
      const mainAddButton = document.querySelector('.product-form__submit');
      const isSingleUSize = mainAddButton && mainAddButton.hasAttribute('data-single-u-size');

      if (isSingleUSize) {
        // For single U size products, add to cart directly via API
        console.log('Single U size product - adding to cart via API');

        // Add loading state to sticky button only
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        const btnText = btn.querySelector('span');
        const loader = btn.querySelector('.loading-overlay__spinner');
        if (btnText) btnText.classList.add('hidden');
        if (loader) loader.classList.remove('hidden');

        // Get variant ID from the form
        const productForm = document.querySelector('product-form form');
        const variantId = productForm?.querySelector('input[name="id"]')?.value;

        if (variantId) {
          // Add to cart via fetch
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', 1);

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          })
            .then(response => {
              if (!response.ok) throw new Error(`HTTP ${response.status}`);
              return response.json();
            })
            .then(data => {
              // Open minicart with product info
              if (window.minicart && typeof window.minicart.open === 'function') {
                window.minicart.open({
                  title: 'Añadido a la cesta',
                  productTitle: data.product_title || '',
                  imageSrc: data.image || '',
                  imageAlt: data.product_title || '',
                  priceText: data.price ? new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(data.price / 100) : '',
                  variantText: '',
                });
              }

              // Update cart count
              fetch(window.Shopify.routes.root + 'cart.js')
                .then(r => r.json())
                .then(cart => {
                  const cartBubble = document.querySelector('.wt-header__panel__counter');
                  if (cartBubble) cartBubble.textContent = cart.item_count;
                });

              // Notify cart-sync and other components
              if (typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'pdp',
                  productVariantId: variantId,
                  cartData: data
                });
              }
            })
            .catch(error => {
              console.error('Error adding to cart:', error);
              // Remove loading state on error
              btn.removeAttribute('aria-disabled');
              btn.classList.remove('loading');
              if (btnText) btnText.classList.remove('hidden');
              if (loader) loader.classList.add('hidden');
            });
        }

        // Listen for minicart open event to remove loading state
        const removeLoading = () => {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (btnText) btnText.classList.remove('hidden');
          if (loader) loader.classList.add('hidden');
          window.removeEventListener('minicart:open', removeLoading);
        };
        window.addEventListener('minicart:open', removeLoading);

        return;
      }

      // Check if we should show mobile size modal
      if (this.shouldShowMobileSizeModal()) {
        this.openMobileSizeModal();
        return;
      }

      addToCartModule.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    });

    const observer = new IntersectionObserver(entries => {
      entries.forEach(({ isIntersecting, target }) => {
        isIntersecting ? intersected.push(target) : (intersected = intersected.filter(item => item !== target));
      });

      if (intersected.length) {
        this.classList.remove(this.activeClass);
      } else {
        this.classList.add(this.activeClass);
      }
    });

    forObserver.forEach(item => {
      observer.observe(item);
    });
  }

  // Mobile size modal helper methods
  shouldShowMobileSizeModal() {
    // Check if we're on mobile
    if (window.innerWidth >= 768) {
      return false;
    }

    // Check if there are size options in variant-options
    const variantOptions = document.querySelector('variant-options');
    if (!variantOptions) return false;

    // Look for size options in variant picker using data-option-type attribute
    const sizeOptions = variantOptions.querySelectorAll('input[type="radio"][data-option-type="size"]');

    if (sizeOptions.length === 0) return false;

    // Always show modal on mobile if we have size options
    // This ensures that clicking the sticky button allows re-selecting/confirming size
    // instead of just scrolling to the form
    return true;
  }

  openMobileSizeModal() {
    const modal = document.querySelector('#sheet-size');

    if (modal) {
      // Initialize modal if not already done
      if (!window.mobileSizeModal) {
        // eslint-disable-next-line no-undef
        window.mobileSizeModal = new MobileSizeModal();
      }

      if (window.mobileSizeModal && typeof window.mobileSizeModal.open === 'function') {
        // Clear force flag once the modal is about to open
        this.forceSizeModal = false;
        window.mobileSizeModal.open();
      }
    }
  }
}

customElements.define('sticky-buy-button', StickyBuyButton);

function sampleAndUpdate(img, pictureRect, headerBottom) {
  try {
    const sampleW = 60;
    const sampleH = Math.min(60, Math.max(1, Math.floor(headerBottom - Math.max(0, pictureRect.top))));
    const canvas = document.createElement('canvas');
    canvas.width = sampleW;
    canvas.height = sampleH;

    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    const scaleX = img.naturalWidth / img.offsetWidth;
    const scaleY = img.naturalHeight / img.offsetHeight;
    const sy = Math.max(0, -pictureRect.top) * scaleY;
    const sx = (img.offsetWidth - sampleW) * scaleX;

    ctx.drawImage(img, sx, sy, sampleW * scaleX, sampleH * scaleY, 0, 0, sampleW, sampleH);
    const data = ctx.getImageData(0, 0, sampleW, sampleH).data;

    let luminance = 0;
    for (let i = 0; i < data.length; i += 4) {
      luminance += 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
    }
    luminance /= data.length / 4;

    if (luminance > 140) {
      document.body.classList.add('wt-header--icons-dark');
      document.body.classList.remove('wt-header--icons-light');
    } else {
      document.body.classList.add('wt-header--icons-light');
      document.body.classList.remove('wt-header--icons-dark');
    }
  } catch (e) {
    // CORS blocked or other error — leave icons unchanged
  }
}

if (!customElements.get('gallery-fashion')) {
  customElements.define(
    'gallery-fashion',
    class GalleryFashion extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest('section');
        this.logoBanner = this;
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.removeEventsWhenDesignMode();
      }

      addEventsWhenDesignMode() {
        if (Shopify.designMode) {
          document.addEventListener('shopify:section:load', this.reinitAfterDelay);
          document.addEventListener('shopify:section:unload', this.reinitAfterDelay);
        }
      }

      removeEventsWhenDesignMode() {
        if (Shopify.designMode) {
          document.removeEventListener('shopify:section:load', this.reinitAfterDelay);
          document.removeEventListener('shopify:section:unload', this.reinitAfterDelay);
        }
      }

      reinitAfterDelay() {
        setTimeout(() => this.reinit(), 0);
      }

      isFirstSection() {
        const sectionWrapper = document.querySelector('#root');
        const firstSection = sectionWrapper.querySelector('section');
        this.section = this.closest('section');
        const currentSection = this.section;

        return firstSection === currentSection;
      }

      handleResize() {
        this.setTopMargin();
        this.positioningProductInfo();
      }

      observeHeader() {
        const header = document.querySelector('.wt-header');
        const activeTransparentClass = 'wt-header--fashion-transparent';

        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                header.classList.remove(activeTransparentClass);
              } else {
                header.classList.add(activeTransparentClass);
              }
            });
          },
          { root: null, threshold: 0.05 }
        );

        observer.observe(this.querySelector('.wt-product__gallery'));
      }

      calculateOffset() {
        const header = document.querySelector('header');
        const headerHeight = Math.ceil(header.getBoundingClientRect().height);
        const offset = this.isTransparentHeaderEnabled() && this.isFirstSection() ? headerHeight : 0;

        return offset;
      }

      setTopMargin() {
        const offset = this.calculateOffset();
        if (offset) {
          this.section.style.marginTop = `-${offset}px`;
        } else {
          this.section.style.marginTop = 0;
        }
      }

      isTransparentHeaderEnabled() {
        const header = document.querySelector('.wt-header');
        return header.dataset.transparent && header.classList.contains('wt-header--v3');
      }

      renderProgressBar() {
        const thumbsGallery = this.querySelector('[data-thumbs]');
        const progressBarElement = document.createElement('div');
        progressBarElement.classList.add('gallery-fashion__progress-bar');
        const progressBarIndicatorElement = document.createElement('div');
        progressBarIndicatorElement.classList.add('gallery-fashion__progress-bar-indicator');
        progressBarElement.appendChild(progressBarIndicatorElement);
        thumbsGallery.appendChild(progressBarElement);

        function updateProgressBar() {
          const images = this.querySelector('gallery-section');
          const progressBar = progressBarIndicatorElement;

          const scrolled = window.scrollY;
          const maxHeight = images.clientHeight - window.innerHeight;
          const scrollPercentage = (scrolled / maxHeight) * 100;

          const progressBarHeight = progressBarElement.clientHeight;
          const progressHeight = progressBar.clientHeight;
          const maxProgressTop = progressBarHeight - progressHeight;
          const progressTop = Math.min((scrollPercentage / 100) * maxProgressTop, maxProgressTop);

          progressBar.style.top = `${progressTop}px`;

          if (progressTop === maxProgressTop) {
            thumbsGallery.classList.add('finished');
          } else {
            thumbsGallery.classList.remove('finished');
          }
        }

        window.addEventListener('scroll', updateProgressBar.bind(this));

        function handleThumbsClick(event) {
          if (event.target.className === 'wt-product__img') {
            const thumbnails = Array.from(event.currentTarget.querySelectorAll('img'));
            const index = thumbnails.indexOf(event.target);

            const fullImage = this.querySelectorAll('.wt-masonry__wrapper .wt-product__img, .wt-masonry__wrapper .wt-product__thumbnail-video')[index];

            fullImage.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }

        thumbsGallery.addEventListener('click', handleThumbsClick.bind(this));
      }

      positioningProductInfo() {
        const productInfo = this.querySelector('.wt-product__main');
        const mediaDesktop = window.matchMedia('(min-width: 1200px)');

        if (mediaDesktop.matches) {
          productInfo.style.top = `${Math.max((window.innerHeight - productInfo.offsetHeight) / 2, 0)}px`;
        }

        const resizeObserver = new ResizeObserver(() => {
          if (mediaDesktop.matches) {
            productInfo.style.top = `${Math.max((window.innerHeight - productInfo.offsetHeight) / 2, 0)}px`;
          }
        });

        const observedElement = productInfo;
        resizeObserver.observe(observedElement);
      }

      attachEvents() {
        window.addEventListener('resize', this.handleResize.bind(this));
      }

      init() {
        this.reinitAfterDelay = this.reinitAfterDelay.bind(this);
        if (this.isTransparentHeaderEnabled()) {
          const stickyHeaderThreshold = document.querySelector('.sticky-header__threshold');
          const isHeaderSticky = document.body.classList.contains('page-header-sticky');
          if (isHeaderSticky) {
            stickyHeaderThreshold.style.height = `${this.querySelector('.swiper-wrapper--masonry').offsetHeight}px`;
          }
          this.setTopMargin();
          this.observeHeader();
          this.attachEvents();
        }

        this.renderProgressBar();
        this.positioningProductInfo();
        this.addEventsWhenDesignMode();
      }

      reinit() {
        if (this.isTransparentHeaderEnabled()) {
          const stickyHeaderThreshold = document.querySelector('.sticky-header__threshold');
          const isHeaderSticky = document.body.classList.contains('page-header-sticky');
          if (isHeaderSticky) {
            stickyHeaderThreshold.style.height = `${this.querySelector('.swiper-wrapper--masonry').offsetHeight}px`;
          }
          this.setTopMargin();
          this.observeHeader();
        }
        this.positioningProductInfo();
      }
    }
  );
}

// Safari iOS: trigger 1px window scroll on load so the browser chrome collapses
if (/iPhone|iPad/.test(navigator.userAgent)) {
  window.scrollTo(0, 1);
}

// Header icon color detection based on product gallery image brightness.
// Only meaningful when the header can be transparent (desktop, before
// scrolling past the top image) — on mobile the header always has a solid
// white background (scss/pages/_product.scss), so switching icons to white
// there makes them disappear against it instead of improving contrast.
(function initHeaderIconColor() {
  if (window.innerWidth < 1024) return;

  const header = document.getElementById('header');
  const pictures = document.querySelectorAll('.brn-product__gallery__picture');
  if (!header || !pictures.length) return;

  const scrollContainer = window;

  let debounceTimer = null;

  const detect = () => {
    const headerBottom = header.getBoundingClientRect().bottom;
    for (const picture of pictures) {
      const rect = picture.getBoundingClientRect();
      if (rect.top < headerBottom && rect.bottom > 0) {
        const img = picture.querySelector('img');
        if (img && img.complete && img.naturalWidth) {
          sampleAndUpdate(img, rect, headerBottom);
        }
        break;
      }
    }
  };

  scrollContainer.addEventListener('scroll', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(detect, 50);
  }, { passive: true });

  // Run once on load (image may already be decoded)
  if (document.readyState === 'complete') {
    detect();
  } else {
    window.addEventListener('load', detect, { once: true });
  }
}());
